import axios from "axios";
import { getToken } from "../../Utils/UpdateUsersState";

const getSuspectedTheft = async (start_date, end_date) => {
  try {
    const token = getToken();

    const response = await axios.get(
      `${process.env.REACT_APP_BACKEND_URL}user_panel/vehicles/suspected-theft`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
        params: {
          start_date,
          end_date,
        },
      },
    );

    return response;
  } catch (error) {
    console.error("Suspected theft data fetch error:", error);
    throw error;
  }
};

export { getSuspectedTheft };
